export default __webpack_public_path__ + "static/media/5w40.b374a0fd.png";